module.exports = __webpack_public_path__ + "img/Flex@2x.53a98729.png";